import { z } from 'zod';
import type { BaseEntity } from './common';
import type { PurchaseOrder } from './purchaseOrder';
import { IntegrationSystemEnum } from './integrationSystem';

/**
 * PurchaseOrderIntegration - Integrazione ordine di acquisto
 * Rappresenta un'integrazione di un ordine di acquisto con sistemi esterni
 * Corrisponde al modello backend PurchaseOrderIntegration
 */
export interface PurchaseOrderIntegration extends BaseEntity {
	/** ID dell'ordine di acquisto sorgente */
	sourceId: number;
	/** Sistema di integrazione */
	system: IntegrationSystemEnum;
	/** Valore dell'integrazione nel sistema esterno (max 50 caratteri) */
	value: string;
	/** Ordine di acquisto sorgente (navigation property, popolata con $expand=source) */
	source?: PurchaseOrder;
}

/**
 * Schema Zod per la validazione runtime dei PurchaseOrderIntegration
 */
export const PurchaseOrderIntegrationSchema = z.object({
	id: z.number(),
	sourceId: z.number(),
	system: z.nativeEnum(IntegrationSystemEnum),
	value: z.string(),
	// Campi audit da BaseEntity
	createdAt: z.string(),
	modifiedAt: z.string().optional(),
	createdBy: z.string(),
	modifiedBy: z.string().optional(),
	// Navigation property opzionale (non validata in runtime)
	source: z.any().optional(),
});
